import type { Icon } from "iconsax-react";
import {
  Box1,
  DocumentText,
  Forbidden,
  ShieldTick,
  Shop,
  UserSquare,
  WalletMoney,
} from "iconsax-react";

export type TermsSection = {
  id: string;
  navLabel: string;
  titleKey: string;
  bodyKey: string;
  Icon: Icon;
};

export const TERMS_SECTIONS: TermsSection[] = [
  {
    id: "s1",
    navLabel: "ماهیت خدمات",
    titleKey: "sections.s1.title",
    bodyKey: "sections.s1.body",
    Icon: Shop,
  },
  {
    id: "s2",
    navLabel: "حساب کاربری",
    titleKey: "sections.s2.title",
    bodyKey: "sections.s2.body",
    Icon: UserSquare,
  },
  {
    id: "s3",
    navLabel: "محصولات و سفارش‌ها",
    titleKey: "sections.s3.title",
    bodyKey: "sections.s3.body",
    Icon: Box1,
  },
  {
    id: "s4",
    navLabel: "پرداخت‌ها و کارمزد",
    titleKey: "sections.s4.title",
    bodyKey: "sections.s4.body",
    Icon: WalletMoney,
  },
  {
    id: "s5",
    navLabel: "حریم خصوصی",
    titleKey: "sections.s5.title",
    bodyKey: "sections.s5.body",
    Icon: ShieldTick,
  },
  {
    id: "s6",
    navLabel: "تعلیق حساب",
    titleKey: "sections.s6.title",
    bodyKey: "sections.s6.body",
    Icon: Forbidden,
  },
  {
    id: "s7",
    navLabel: "تغییر قوانین",
    titleKey: "sections.s7.title",
    bodyKey: "sections.s7.body",
    Icon: DocumentText,
  },
];
